import { useMemo } from 'react';
import useFetchContentUsageLimit from './useFetchContentUsageLimit';
const formatContentUsageLimitData = (usageLimitResponse, limitNameToLimitTypeMap) => {
  return usageLimitResponse === null || usageLimitResponse === void 0 ? void 0 : usageLimitResponse.reduce((acc, {
    limitName,
    quantityUsed,
    limit
  }) => {
    if (limitName in limitNameToLimitTypeMap) {
      const newKey = limitNameToLimitTypeMap[limitName];
      acc[newKey] = {
        quantityUsed,
        limit
      };
    } else {
      acc[limitName] = {
        quantityUsed,
        limit
      };
    }
    return acc;
  }, {});
};
const useFetchContentUsageLimits = ({
  limitNameToLimitTypeMap,
  shouldFetchUsageLimits,
  contentObjectType,
  contentGroupObjectType
}) => {
  const {
    contentUsageLimit: contentObjectUsageLimit,
    loading: contentObjectUsageLimitRequestLoading,
    error: contentObjectUsageLimitRequestError,
    called: contentObjectUsageLimitRequestStarted
  } = useFetchContentUsageLimit({
    contentObjectType,
    skip: !shouldFetchUsageLimits
  });
  const {
    contentUsageLimit: contentGroupUsageLimit,
    loading: contentGroupUsageLimitRequestLoading,
    error: contentGroupUsageLimitRequestError,
    called: contentGroupUsageLimitRequestStarted
  } = useFetchContentUsageLimit({
    contentObjectType: contentGroupObjectType,
    skip: !shouldFetchUsageLimits
  });
  const limitsData = useMemo(() => {
    const formattedContentObjectUsageLimit = formatContentUsageLimitData(contentObjectUsageLimit, limitNameToLimitTypeMap);
    const formattedContentGroupUsageLimit = formatContentUsageLimitData(contentGroupUsageLimit, limitNameToLimitTypeMap);
    return Object.assign({}, formattedContentObjectUsageLimit, formattedContentGroupUsageLimit);
  }, [contentGroupUsageLimit, contentObjectUsageLimit, limitNameToLimitTypeMap]);
  const contentUsageLimitRequestsSucceeded = useMemo(() => {
    return !contentObjectUsageLimitRequestLoading && !contentGroupUsageLimitRequestLoading && !contentObjectUsageLimitRequestError && !contentGroupUsageLimitRequestError;
  }, [contentObjectUsageLimitRequestLoading, contentGroupUsageLimitRequestLoading, contentObjectUsageLimitRequestError, contentGroupUsageLimitRequestError]);
  return {
    limitsData,
    contentObjectUsageLimitRequestStarted,
    contentObjectUsageLimitRequestLoading,
    contentObjectUsageLimitRequestError,
    contentGroupUsageLimitRequestStarted,
    contentGroupUsageLimitRequestLoading,
    contentGroupUsageLimitRequestError,
    contentUsageLimitRequestsSucceeded
  };
};
export default useFetchContentUsageLimits;